import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Catches uncaught client-side errors (template/rendering bugs, not API failures --
 * those go through problem-details.interceptor.ts instead). Logs only for now; wiring to
 * a remote logging sink is an infrastructure decision for a later sprint, not part of the
 * Sprint 1 foundation.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    console.error('Unhandled client error:', error);
  }
}
